<template>
	<div class="col-md-12">
        <alerts :status="alert" v-model="alert"></alerts>
        <div class="card panel panel-default mb-4">
            <div class="card-block">
                <div class="header-block d-flex justify-content-between align-items-center">
                    <h3 class="pull-left">{{ workflowName }}</h3>
                    <button class="btn btn-primary pull-right" data-toggle="collapse" data-target="#edit_workflow" v-if="canManageWorkflow">
                        Edit
                    </button>
                </div>

                <edit-workflow-form @alert="handleAlert" :workflow="workflow" />
            </div>
        </div>
        <workflow-projects-listing @alert="handleAlert" :workflow-id="workflow.id" />
	</div>
</template>

<style scoped lang="scss">
.project-listing__item-actions {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.btn-actions {
    margin-right: 0.5rem;
}
</style>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import VueEvents from "vue-events";
import ProjectsListing from "./workflow-projects-listing.vue";
import EditWorkflowForm from "./edit-workflow-form.vue";
import WorkflowRestrictUser from "./workflow-restrict-user.vue";
import ProductAlerts from "../products/product-details-alerts.vue";

Vue.use(VueEvents);

export default {
    name: "EditWorkflow",
    props: [
        'workflow'
    ],
    components: {
        "workflow-projects-listing": ProjectsListing,
        "workflow-restrict-user": WorkflowRestrictUser,
        "alerts": ProductAlerts,
        "edit-workflow-form": EditWorkflowForm
    },
    mounted() {},
    data() {
        return {
            alert: {
                message: "",
                status: "",
                timeOut: 15000,
            },
            workflowName: this.workflow.name || 'Workflow Name'
        }
    },
    methods: {
        handleAlert(alert) {
            this.alert.message = alert.message;
            this.alert.status = alert.status;
        },
    },
    computed: {
        canManageWorkflow: function() {
            return this.$root.enabledPermissions.includes('manage_workflow');
        }
    }
};
</script>
